import React from 'react'
import { Button } from 'antd'
import PayCard from '../../../components/comment/paymentCard/paymentCard'

const selectCard = () => {
  return (
    <section className='select-card'>
    <div className="row">
        <div className="col-lg-12">
        <div className="rightbar-title">
        saved card
    </div>
        </div>
    </div>
 
 <div className="row">
    <div className="col-lg-12">
        <div className="add-pay-method-wrap">
            <div className='title-pay-method'> Select how to pay for booking</div>
            <Button type='primary' className='pay-method-btn'>Add New Card</Button>
        </div>
    </div>
 </div>

 <div className="row">
    <div className="col-lg-12">
        <PayCard />
    </div>
 </div>
 <div className="row">
    <div className="col-lg-12">
        <PayCard />
    </div>
 </div>
 <div className="row">
    <div className="col-lg-12">
        <PayCard />
    </div>
 </div>

    </section>
  )
}

export default selectCard